// src/redux/slices/cartSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], // Each item: { cartId, customerId, productId, quantity }
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      // Only keep essential fields
      state.items = action.payload.map(item => ({
        cartId: item.cartId,
        customerId: item.customerId,
        productId: item.productId,
        quantity: item.quantity || 1,
      }));
    },
    updateCartItemQuantity: (state, action) => {
      const { cartId, quantity } = action.payload;      
      if (quantity < 1) return;
      const item = state.items.find(i => i.cartId === cartId);
      if (item) {
        item.quantity = quantity;
      }
    },
    removeCartItem: (state, action) => {
      const cartId = action.payload;
      state.items = state.items.filter(item => item.cartId !== cartId);
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const {
  setCartItems,
  updateCartItemQuantity,
  removeCartItem,
  clearCart,
} = cartSlice.actions;

export default cartSlice.reducer;
